import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_PART_MANAGER } from '../redux/constants/rolesConstants';
import PartsHeader from '../components/parts/PartsHeader';
import PartsList from '../components/parts/PartsList';
import PartsPagination from '../components/parts/PartsPagination';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';

const Parts = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_PART_MANAGER));
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Запчастини'} />
        </PageTitleContainer>
        <Container>
          <PartsHeader readOnly={readOnly} />
          <PartsList readOnly={readOnly} />
          <PartsPagination />
        </Container>
      </section>
    </Suspense>
  );
};

export default Parts;
